const registerModal = {
  show(): void {
    const path = window.location.pathname;

    // Only run on home page
    if (path !== '/') {
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);

    const registerParam = urlParams.get('register');
    const triggerRegisterModal = registerParam === '1';
    if (!triggerRegisterModal) {
      return;
    }

    const $registerModal = $('#registerModal');
    if ($registerModal.length <= 0) {
      return;
    }

    $registerModal.modal('show');
  },
};

document.addEventListener('DOMContentLoaded', () => {
  registerModal.show();
});
